import { styled } from '@mui/system';
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import imgNotFound from '../../assets/img/404.svg';

const Container = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
});

const Wrapper = styled(Box)({
    maxWidth: 480,
    mx: 'auto',
    display: 'flex',
    minHeight: '100vh',
    textAlign: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
});

const Title = styled(Typography)({
    marginBottom: '12px',
});
const Text = styled(Typography)({
    marginBottom: '12px',
});

const ImgContainer = styled(Box)({
    mx: 'auto',
    height: 260,
    my: { xs: 5, sm: 10 },
});

const NotFoundView = () => {
    const navigate = useNavigate();

    return (
        <Container>
            <Wrapper py={12}>
                <Title variant='h3'>Desculpe, página não encontrada!</Title>

                <Text sx={{ color: 'text.secondary' }}>
                    Lamentamos, mas não conseguimos encontrar a página que procura. Talvez você tenha digitado incorretamente o URL? Certifique-se de verificar sua ortografia.
                </Text>

                <ImgContainer
                    component="img"
                    src={imgNotFound}
                    // src='https://minimal-kit-react.vercel.app/assets/illustrations/illustration_404.svg'
                />

                <Box mt={4}><Button onClick={() => navigate(-1)} size="large" variant="contained">
                    Voltar
                </Button></Box>
            </Wrapper>
        </Container>
    )
}
export default NotFoundView;